import React from 'react';
import { ConnectedDynpackManager } from './DynpackManager';
import { ConnectedSegmentManagerDp } from './SegmentManagerDp';
import { CMS } from '../../utils/CMS';
import { ABUtils } from '../../utils';
import CalendarContextProvider from '../FlightsManager/CalendarContext';

export const DynpackManagerDesktop = () => {
    const { isAbTrain } = ABUtils.getABs();
    const bannerKeyId = isAbTrain ? 'flightsManager.banner.upper.dp.TRAINS' : 'flightsManager.banner.upper.dp.main';
    return (
        <ConnectedDynpackManager render={() => (
            <React.Fragment>
                <CalendarContextProvider>
                    <div className="odf-text-positive odf-space-inner-left-m odf-space-inner-top-m odf-space-inner-right-m">
                        <span className="odf-icon odf-icon-tick odf-icon-l odf-space-inner-right-xs" />
                        <span className="odf-text-md odf-space-inner-right-md">
                            <CMS id={bannerKeyId} />
                        </span>
                    </div>
                    <div className="odf-box odf-space-inner-m odf-position-relative">
                        <ConnectedSegmentManagerDp />
                    </div>
                </CalendarContextProvider>
            </React.Fragment>
        )}
        />
    );
};
